module.exports = __webpack_public_path__ + "static/livesession-summary-399df3a0a0645a8163843882f2af2483.png";